/**
 * Legacy /profile route — redirects into the Account hub Identity tab.
 */
import { Navigate } from "react-router-dom";

export function ProfilePage() {
	return <Navigate to="/account?tab=identity" replace />;
}
